import { ActivityByActionChart } from './ActivityByActionChart';
import { ActivityTrendChart } from './ActivityTrendChart';
import { GrowthTrendChart } from './GrowthTrendChart';
import { WorkspaceStatusChart } from './WorkspaceStatusChart';
import { WorkspaceTypeChart } from './WorkspaceTypeChart';

interface DashboardChartsSectionProps {
  isEnabled: boolean;
}

export function DashboardChartsSection({ isEnabled }: DashboardChartsSectionProps) {
  return (
    <div className="space-y-5">
      <GrowthTrendChart isEnabled={isEnabled} />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <ActivityTrendChart isEnabled={isEnabled} />
        <ActivityByActionChart isEnabled={isEnabled} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <WorkspaceStatusChart isEnabled={isEnabled} />
        <WorkspaceTypeChart isEnabled={isEnabled} />
      </div>
    </div>
  );
}
